module.exports = __webpack_public_path__ + "img/calendar_next_meeting.041e02e4.png";